import React from 'react';
import { Translate } from 'react-redux-i18n';
import { css } from 'aphrodite/no-important';
import styles from './SelectGrid.styles';

import Icon from '../../common/icon/Icon';

const SelectGrid = props => {
  const { options, onChange, value, customStyles, ...rest } = props;
  const onSelect = itemValue => {
    if (!value) {
      onChange(itemValue);
    } else {
      if (value === itemValue) {
        onChange(null);
      } else {
        onChange(itemValue);
      }
    }
  };
  return (
    <div className={css(styles.container, customStyles)} {...rest}>
      {options &&
        options.length &&
        options.map((item, index) => (
          <div
            key={index}
            className={css(styles.item)}
            onClick={() => onSelect(item.value)}
          >
            <div
              className={css(
                styles.innerItem,
                value === item.value && styles.selected
              )}
            >
              <Icon value={item.icon} styles={styles.icon} />
              <span>
                <Translate value={item.label} />
              </span>
            </div>
          </div>
        ))}
    </div>
  );
};

export default SelectGrid;



// WEBPACK FOOTER //
// ./src/components/inputs/selectgrid/SelectGrid.js